import Component from '@glimmer/component';
import { STATUS_KEYS } from 'scaleflow/models/initiative-update';

export default class InitiativesTableProgressPillIndexComponent extends Component {
  status_keys = STATUS_KEYS;
}
